import { useState, useEffect } from "react";
import {
  saveItemDetails,
  fetchMerchantCodes,
  fetchCountryCodes,
  fetchRegionsByCountry,
  fetchItemTypes,
  fetchSKUUnits,
  fetchItemGroups,
  fetchValuationMethods,
  fetchTaxCategories,
  fetchWeightUnits,
  fetchWarehouses,
  fetchManufacturers,
  fetchItemGroups1ByItemGroupCode,
  fetchItemGroups2ByItemGroup1,
  fetchItemGroups3ByItemGroup2,
  fetchBrandGroups,
  fetchItemGroupsByItemType,
  fetchBrandsByGroup,
  fetchAllItems,
} from "../Api/Item";
import { fetchItemsByOrgId } from "../Api/IncomingPo";
import { fetchOfficeByOrgId } from "../Api/InvoiceApi";
import { getAllMerchants } from "../Api/CustomerMaster";
import { Container, Form, Button, Row, Col, Accordion } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";
import { useAuth } from "../Context/AuthContext";
import { fetchCompnayCodesById } from "../Api/InvoiceApi";
/*import "../Styling/ItemMaster.css";*/
import "../Styling/Title.css";
import "../Styling/Accordion.css";
import "../Styling/CopyButton.css";
import "../Styling/SaveButton.css";

import { FaBuilding, FaBoxOpen, FaEllipsisH, FaCopy } from "react-icons/fa";

const ItemMaster = () => {
  const { user } = useAuth();
  const [itemData, setItemData] = useState({
    item_name: "",
    item_type: "",
    sku_unit: "",
    item_group: "",
    valuation_method: "",
    active_status: "Active",
    manufacturer: "",
    tax_Category: "",
    weight: "",
    gtin: "",
    default_Warehouse: "",
    item_group1: "",
    item_group2: "",
    item_group3: "",
    item_indicator1: "",
    item_indicator2: "",
    item_indicator3: "",
    merchant_code: "",
    country_code: "",
    region_code: "",
    pack_size: "",
    brandGroup: "",
    brand: "",
    price: "",
    organisationId: user?.organisationId,
    companyCode: "",
    hsnId: "",
  });
  const [loading, setLoading] = useState(false);
  const [fetchingData, setFetchingData] = useState(true);
  const navigate = useNavigate();
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;
  const [allItems, setAllItems] = useState([]);
  const [selectedItemCode, setSelectedItemCode] = useState("");

  // dropdown option states
  const [merchantOptions, setMerchantOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [regionOptions, setRegionOptions] = useState([]);
  const [itemTypeOptions, setItemTypeOptions] = useState([]);
  const [skuUnitOptions, setSkuUnitOptions] = useState([]);
  const [itemGroupOptions, setItemGroupOptions] = useState([]);
  const [valuationMethodOptions, setValuationMethodOptions] = useState([]);
  const [taxCategoryOptions, setTaxCategoryOptions] = useState([]);
  const [weightUnitOptions, setWeightUnitOptions] = useState([]);
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [itemGroup1Options, setItemGroup1Options] = useState([]);
  const [itemGroup2Options, setItemGroup2Options] = useState([]);
  const [itemGroup3Options, setItemGroup3Options] = useState([]);
  const [manufacturerOptions, setManufacturerOptions] = useState([]);
  const [brandGroupOptions, setBrandGroupOptions] = useState([]);
  const [brandOptions, setBrandOptions] = useState([]);
  const [companyCode, setCompanyCodes] = useState([]);
  // GST registration toggle
  const [isGstRegistered, setIsGstRegistered] = useState(
    Boolean(itemData.hsnId)
  );

  // helpers
  const isServiceItem = itemData.item_type === "SR00";
  const requiresBrandFields =
    itemData.item_type === "CM00" || itemData.item_type === "FM00";

  // Fetch initial dropdown data and set default companyCode / default_Warehouse to first available
  useEffect(() => {
    if (!isGstRegistered) {
      setItemData((prev) => ({ ...prev, hsnId: "" }));
    }
  }, [isGstRegistered]);

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const [
          merchants,
          countries,
          itemTypes,
          skuUnits,
          itemGroups,
          valuationMethods,
          taxCategories,
          weightUnits,
          warehouses,
          manufacturers,
          brandGroups,
          fetchedCompanyCodes,
        ] = await Promise.all([
          getAllMerchants(user?.organisationId),
          fetchCountryCodes(),
          fetchItemTypes(),
          fetchSKUUnits(),
          fetchItemGroups(),
          fetchValuationMethods(),
          fetchTaxCategories(),
          fetchWeightUnits(),
          fetchOfficeByOrgId(user?.organisationId),
          getAllMerchants(user?.organisationId), // this seems duplicated in original; kept as-is
          fetchBrandGroups(),
          fetchCompnayCodesById(user?.organisationId),
        ]);

        setMerchantOptions(merchants);
        setCountryOptions(countries);
        setItemTypeOptions(itemTypes);
        setSkuUnitOptions(skuUnits);
        setItemGroupOptions(itemGroups);
        setValuationMethodOptions(valuationMethods);
        setTaxCategoryOptions(taxCategories);
        setWeightUnitOptions(weightUnits);
        setWarehouseOptions(warehouses);
        setManufacturerOptions(manufacturers);
        setBrandGroupOptions(brandGroups);
        setRegionOptions([]);
        setCompanyCodes(fetchedCompanyCodes);
        const items = await fetchItemsByOrgId(user?.organisationId);
        setAllItems(items || []);

        // set defaults to first values if available
        setItemData((prev) => ({
          ...prev,
          companyCode:
            fetchedCompanyCodes?.[0]?.companyCode || prev.companyCode,
          default_Warehouse:
            warehouses?.[0]?.officeCode || prev.default_Warehouse,
        }));
      } catch (error) {
        toast.error(
          `🦄 Error loading dropdown data: ${error?.message || error}`
        );
      } finally {
        setFetchingData(false);
      }
    };

    fetchDropdownData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Fetch Item Groups when Item Type changes
  useEffect(() => {
    const fetchFilteredItemGroups = async () => {
      if (itemData.item_type) {
        setLoading(true);
        try {
          const filteredGroups = await fetchItemGroupsByItemType(
            itemData.item_type
          );
          setItemGroupOptions(filteredGroups);
          // Reset item group and cascading groups when item type changes
          setItemData((prev) => ({
            ...prev,
            item_group: "",
            item_group1: "",
            item_group2: "",
            item_group3: "",
          }));
          setItemGroup1Options([]);
          setItemGroup2Options([]);
          setItemGroup3Options([]);
        } catch (error) {
          toast.error(
            `🦄 Failed to load Item Groups for selected type: ${error.message}`
          );
          setItemGroupOptions([]);
        } finally {
          setLoading(false);
        }
      } else {
        // If no item type selected, show all item groups
        const fetchAllItemGroups = async () => {
          try {
            const allGroups = await fetchItemGroups();
            setItemGroupOptions(allGroups);
          } catch (error) {
            toast.error(`🦄 Failed to load Item Groups: ${error.message}`);
            setItemGroupOptions([]);
          }
        };
        fetchAllItemGroups();

        // Reset item group and cascading groups
        setItemData((prev) => ({
          ...prev,
          item_group: "",
          item_group1: "",
          item_group2: "",
          item_group3: "",
        }));
        setItemGroup1Options([]);
        setItemGroup2Options([]);
        setItemGroup3Options([]);
      }
    };

    fetchFilteredItemGroups();
  }, [itemData.item_type]);

  // Fetch Regions when Country changes
  useEffect(() => {
    const fetchRegionData = async () => {
      if (itemData.country_code) {
        setLoading(true);
        try {
          const regions = await fetchRegionsByCountry(itemData.country_code);
          setRegionOptions(regions);
          // Reset region code when country changes
          setItemData((prev) => ({
            ...prev,
            region_code: "",
          }));
        } catch (error) {
          toast.error(`🦄 Failed to load Regions: ${error.message}`);
          setRegionOptions([]);
        } finally {
          setLoading(false);
        }
      } else {
        setRegionOptions([]);
        setItemData((prev) => ({
          ...prev,
          region_code: "",
        }));
      }
    };

    if (!isServiceItem) {
      fetchRegionData();
    }
  }, [itemData.country_code, isServiceItem]);

  // Item group cascading effects (unchanged logic)
  useEffect(() => {
    const fetchItemGroup1Data = async () => {
      if (itemData.item_group) {
        setLoading(true);
        try {
          const groups1 = await fetchItemGroups1ByItemGroupCode(
            itemData.item_group
          );
          setItemGroup1Options(groups1);
          setItemData((prev) => ({
            ...prev,
            item_group1: "",
            item_group2: "",
            item_group3: "",
          }));
          setItemGroup2Options([]);
          setItemGroup3Options([]);
        } catch (error) {
          toast.error(`🦄 Failed to load Item Group 1: ${error.message}`);
          setItemGroup1Options([]);
        } finally {
          setLoading(false);
        }
      } else {
        setItemGroup1Options([]);
        setItemGroup2Options([]);
        setItemGroup3Options([]);
      }
    };

    fetchItemGroup1Data();
  }, [itemData.item_group]);

  useEffect(() => {
    const fetchItemGroup2Data = async () => {
      if (itemData.item_group1) {
        setLoading(true);
        try {
          const groups2 = await fetchItemGroups2ByItemGroup1(
            itemData.item_group1
          );
          setItemGroup2Options(groups2);
          setItemData((prev) => ({
            ...prev,
            item_group2: "",
            item_group3: "",
          }));
          setItemGroup3Options([]);
        } catch (error) {
          toast.error(`🦄 Failed to load Item Group 2: ${error.message}`);
          setItemGroup2Options([]);
        } finally {
          setLoading(false);
        }
      } else {
        setItemGroup2Options([]);
        setItemGroup3Options([]);
      }
    };

    fetchItemGroup2Data();
  }, [itemData.item_group1]);

  useEffect(() => {
    const fetchItemGroup3Data = async () => {
      if (itemData.item_group2) {
        setLoading(true);
        try {
          const groups3 = await fetchItemGroups3ByItemGroup2(
            itemData.item_group2
          );
          setItemGroup3Options(groups3);
          setItemData((prev) => ({
            ...prev,
            item_group3: "",
          }));
        } catch (error) {
          toast.error(`🦄 Failed to load Item Group 3: ${error.message}`);
          setItemGroup3Options([]);
        } finally {
          setLoading(false);
        }
      } else {
        setItemGroup3Options([]);
      }
    };

    fetchItemGroup3Data();
  }, [itemData.item_group2]);

  // Brands when Brand Group changes
  useEffect(() => {
    const fetchBrandData = async () => {
      if (itemData.brandGroup) {
        setLoading(true);
        try {
          const brands = await fetchBrandsByGroup(itemData.brandGroup);
          setBrandOptions(brands);
          setItemData((prev) => ({ ...prev, brand: "" }));
        } catch (error) {
          toast.error(`🦄 Failed to load Brands: ${error.message}`);
          setBrandOptions([]);
        } finally {
          setLoading(false);
        }
      } else {
        setBrandOptions([]);
        setItemData((prev) => ({ ...prev, brand: "" }));
      }
    };

    if (requiresBrandFields) {
      fetchBrandData();
    }
  }, [itemData.brandGroup, requiresBrandFields]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setItemData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    if (isGstRegistered && !itemData.hsnId?.trim()) {
      toast.warning("Please enter HSN ID (GST registered is checked).");
      return;
    }

    e.preventDefault();
    setLoading(true);
    try {
      const response = await saveItemDetails(itemData, userId);
      toast.success(
        `🦄 Item with Item Code: ${response.itemCode} added Successfully`
      );
      setItemData({
        item_name: "",
        item_type: "",
        sku_unit: "",
        item_group: "",
        valuation_method: "",
        active_status: "Active",
        manufacturer: "",
        tax_Category: "",
        weight: "",
        gtin: "",
        default_Warehouse:
          warehouseOptions?.[0]?.officeCode || "5001-Sidhidata corp office", // keep default if available
        item_group1: "",
        item_group2: "",
        item_group3: "",
        item_indicator1: "",
        item_indicator2: "",
        item_indicator3: "",
        merchant_code: "",
        country_code: "",
        region_code: "",
        pack_size: "",
        brandGroup: "",
        brand: "",
        price: "",
        organisationId: user?.organisationId,
        companyCode: companyCode?.[0]?.companyCode || "",
        hsnId: "",
        itemId: "",
      });
      setBrandOptions([]);
      setRegionOptions([]);
    } catch (error) {
      toast.error(`🦄 Error saving Item: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };
  const handleCopyItem = () => {
    if (!selectedItemCode)
      return toast.warning("Please select an item to copy");

    const itemToCopy = allItems.find(
      (itm) => itm.itemCode === selectedItemCode
    );

    if (!itemToCopy) {
      toast.error("Selected item not found");
      return;
    }

    setItemData((prev) => ({
      ...prev,
      item_name: "",
      item_type: itemToCopy.itemType || "",
      sku_unit: itemToCopy.skuUnit || "",
      item_group: itemToCopy.itemGroup || "",
      valuation_method: itemToCopy.valuationMethod || "",
      active_status: itemToCopy.activeStatus || "Active",
      manufacturer: itemToCopy.manufacturer || "",
      tax_Category: itemToCopy.taxCategory || "",
      weight: itemToCopy.weight || "",
      gtin: itemToCopy.gtin || "",
      default_Warehouse: itemToCopy.defaultWarehouse || "",
      item_group1: itemToCopy.itemGroup1 || "",
      item_group2: itemToCopy.itemGroup2 || "",
      item_group3: itemToCopy.itemGroup3 || "",
      item_indicator1: itemToCopy.itemIndicator1 || "",
      item_indicator2: itemToCopy.itemIndicator2 || "",
      item_indicator3: itemToCopy.itemIndicator3 || "",
      merchant_code: itemToCopy.merchantCode || "",
      country_code: itemToCopy.countryCode || "",
      region_code: itemToCopy.regionCode || "",
      pack_size: itemToCopy.packSize || "",
      brandGroup: itemToCopy.brandGroup || "",
      brand: itemToCopy.brand || "",
      price: itemToCopy.price || "",
      hsnId: itemToCopy.hsnId || "",
      companyCode: itemToCopy.companyCode || prev.companyCode,
    }));

    // 👇 set the checkbox based on whether HSN exists
    setIsGstRegistered(Boolean(itemToCopy.hsnId));

    toast.success(`Item details copied from ${itemToCopy.itemCode}`);
  };

  return (
    <div className="container item-master-fields">
      <h2 className="fields-title">Item Master</h2>

      {(loading || fetchingData) && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}

      <Form onSubmit={handleSubmit} className="fields-form">
        <Row className="align-items-end mb-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Copy From Item</Form.Label>
              <Form.Select
                value={selectedItemCode}
                onChange={(e) => setSelectedItemCode(e.target.value)}
                disabled={fetchingData || loading}
              >
                <option value="">Select Item to Copy</option>
                {allItems.map((item) => (
                  <option key={item.itemCode} value={item.itemCode}>
                    {item.itemCode} - {item.itemName}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md="auto" xs={12}>
            <Button
              className=" btn-copy w-100"
              variant="success"
              onClick={() => handleCopyItem()}
              disabled={!selectedItemCode}
            >
              Copy
            </Button>
          </Col>
        </Row>

        {/* use Accordion. Leave Company + Item open, Other closed by default */}
        <Accordion defaultActiveKey={["0"]} alwaysOpen>
          {/* Company Details */}
          <Accordion.Item eventKey="0">
            <Accordion.Header as="div" className="_DetailsHeader">
                         <div className="details-header-content employee-header">
                           {/* LEFT: icon + title */}
                           <div className="employee-header-left">
                             <div className="details-icon-card">
                               <FaBuilding />
                             </div>
                             <span className="details-header-text">Company Details</span>
                           </div>
           
                           {/* RIGHT: headings only */}
                           <div className="employee-header-summary">
                             <span>Company Code · Default Warehouse ....</span>
                           </div>
                         </div>
                       </Accordion.Header>

            <Accordion.Body>
              <Row>
                <Form.Group
                  className="mb-1 d-flex align-items-center"
                  controlId="gstRegistered"
                >
                  <Form.Check
                    type="checkbox"
                    className="me-2"
                    label="Registered for GST"
                    checked={isGstRegistered}
                    onChange={(e) => setIsGstRegistered(e.target.checked)}
                    disabled={fetchingData}
                  />
                </Form.Group>
              </Row>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Company Code<span className="text-red">*</span>
                    </Form.Label>
                    <Form.Select
                      name="companyCode"
                      value={itemData.companyCode}
                      onChange={handleChange}
                      required
                      disabled={fetchingData}
                    >
                      <option value="">Select Company Code</option>
                      {companyCode.map((item) => (
                        <option key={item.companyCode} value={item.companyCode}>
                          {item.companyCode} - {item.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Default Warehouse</Form.Label>
                    <Form.Select
                      name="default_Warehouse"
                      value={itemData.default_Warehouse}
                      onChange={handleChange}
                      disabled={fetchingData}
                    >
                      <option value="">Select Warehouse</option>
                      {warehouseOptions.map((warehouse) => (
                        <option
                          key={warehouse.officeCode}
                          value={warehouse.officeCode}
                        >
                          {warehouse.officeCode} - {warehouse.officeName}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
            </Accordion.Body>
          </Accordion.Item>

          {/* Item Details */}
          <Accordion.Item eventKey="1">
      <Accordion.Header as="div" className="_DetailsHeader">
                   <div className="details-header-content employee-header">
                     {/* LEFT: icon + title */}
                     <div className="employee-header-left">
                       <div className="details-icon-card">
                         <FaBoxOpen />
                       </div>
                       <span className="details-header-text">Item Details</span>
                     </div>
     
                     {/* RIGHT: headings only */}
                     <div className="employee-header-summary">
                       <span>Item Name · Item Type · HSN ID ....</span>
                     </div>
                   </div>
                 </Accordion.Header>

            <Accordion.Body>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Item Name <span className="text-red">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="item_name"
                      value={itemData.item_name}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Item Type <span className="text-red">*</span>
                    </Form.Label>
                    <Form.Select
                      name="item_type"
                      value={itemData.item_type}
                      onChange={handleChange}
                      required
                      disabled={fetchingData}
                    >
                      <option value="">Select Item Type</option>
                      {itemTypeOptions.map((item) => (
                        <option key={item.code} value={item.code}>
                          {item.code} - {item.description}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      HSN ID{" "}
                      {isGstRegistered && <span className="text-red">*</span>}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="hsnId"
                      value={itemData.hsnId}
                      onChange={handleChange}
                      disabled={!isGstRegistered || fetchingData}
                      required={isGstRegistered}
                      placeholder={
                        isGstRegistered
                          ? "Enter HSN ID"
                          : "Disabled (Not registered for GST)"
                      }
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      SKU Unit <span className="text-red">*</span>
                    </Form.Label>
                    <Form.Select
                      name="sku_unit"
                      value={itemData.sku_unit}
                      onChange={handleChange}
                      required
                      disabled={fetchingData}
                    >
                      <option value="">Select SKU Unit</option>
                      {skuUnitOptions.map((unit) => (
                        <option key={unit.code} value={unit.code}>
                          {unit.code} - {unit.description}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              {requiresBrandFields && (
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Brand Group</Form.Label>
                      <Form.Select
                        name="brandGroup"
                        value={itemData.brandGroup}
                        onChange={handleChange}
                        disabled={fetchingData}
                      >
                        <option value="">Select Brand Group</option>
                        {brandGroupOptions.map((brandGroup) => (
                          <option key={brandGroup.code} value={brandGroup.code}>
                            {brandGroup.code} - {brandGroup.description}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Brand</Form.Label>
                      <Form.Select
                        name="brand"
                        value={itemData.brand}
                        onChange={handleChange}
                        disabled={!itemData.brandGroup || fetchingData}
                      >
                        <option value="">Select Brand</option>
                        {brandOptions.map((brand) => (
                          <option key={brand.code} value={brand.code}>
                            {brand.code} - {brand.description}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
              )}
            </Accordion.Body>
          </Accordion.Item>

          {/* Other Details - closed by default due to defaultActiveKey above */}
          <Accordion.Item eventKey="2">
            <Accordion.Header as="div" className="_DetailsHeader">
                         <div className="details-header-content employee-header">
                           {/* LEFT: icon + title */}
                           <div className="employee-header-left">
                             <div className="details-icon-card">
                               <FaEllipsisH />
                             </div>
                             <span className="details-header-text">Other Details</span>
                           </div>
           
                           {/* RIGHT: headings only */}
                           <div className="employee-header-summary">
                             <span>Sales Price · Item ID · Pack Size ....</span>
                           </div>
                         </div>
                       </Accordion.Header>

            <Accordion.Body>
              {!isServiceItem && (
                <>
                  <Row className="form-grid-row">
                    <Col xl={4} lg={4} md={6} sm={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>Sales Price</Form.Label>
                        <Form.Control
                          type="text"
                          name="price"
                          value={itemData.price}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col xl={4} lg={4} md={6} sm={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>Item Id</Form.Label>
                        <Form.Control
                          type="text"
                          name="itemId"
                          value={itemData.itemId}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>

                    <Col xl={4} lg={4} md={6} sm={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>Pack Size</Form.Label>
                        <Form.Control
                          type="text"
                          name="pack_size"
                          value={itemData.pack_size}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>

                    <Col xl={4} lg={4} md={6} sm={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>Valuation Method</Form.Label>
                        <Form.Select
                          name="valuation_method"
                          value={itemData.valuation_method}
                          onChange={handleChange}
                          disabled={fetchingData}
                        >
                          <option value="">Select Valuation Method</option>
                          {valuationMethodOptions.map((method) => (
                            <option key={method.code} value={method.code}>
                              {method.code} - {method.description}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col xl={4} lg={4} md={6} sm={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          Active Status<span className="text-red">*</span>
                        </Form.Label>
                        <Form.Select
                          name="active_status"
                          value={itemData.active_status}
                          onChange={handleChange}
                          required
                        >
                          <option value="Active">Active</option>
                          <option value="Inactive">Inactive</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col xl={4} lg={4} md={6} sm={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>Manufacturer</Form.Label>
                        <Form.Select
                          name="manufacturer"
                          value={itemData.manufacturer}
                          onChange={handleChange}
                          disabled={fetchingData}
                        >
                          <option value="">Select Manufacturer</option>
                          {manufacturerOptions.map((manufacturer) => (
                            <option
                              key={manufacturer.vendorCode}
                              value={manufacturer.vendorCode}
                            >
                              {manufacturer.vendorCode} - {manufacturer.name}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col xl={4} lg={4} md={6} sm={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>Tax Category</Form.Label>
                        <Form.Select
                          name="tax_Category"
                          value={itemData.tax_Category}
                          onChange={handleChange}
                          disabled={fetchingData}
                        >
                          <option value="">Select Tax Category</option>
                          {taxCategoryOptions.map((category) => (
                            <option key={category.code} value={category.code}>
                              {category.code} - {category.description}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col xl={4} lg={4} md={6} sm={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>Weight Unit</Form.Label>
                        <Form.Select
                          name="weight"
                          value={itemData.weight}
                          onChange={handleChange}
                          disabled={fetchingData}
                        >
                          <option value="">Select Weight Unit</option>
                          {weightUnitOptions.map((unit) => (
                            <option key={unit.code} value={unit.code}>
                              {unit.code} - {unit.type}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col xl={4} lg={4} md={6} sm={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>GTIN</Form.Label>
                        <Form.Control
                          type="text"
                          name="gtin"
                          value={itemData.gtin}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>

                    <Col xl={4} lg={4} md={6} sm={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>Vendor Code</Form.Label>
                        <Form.Select
                          name="merchant_code"
                          value={itemData.merchant_code}
                          onChange={handleChange}
                          disabled={fetchingData}
                        >
                          <option value="">Select Merchant</option>
                          {manufacturerOptions.map((merchant) => (
                            <option
                              key={merchant.vendorCode}
                              value={merchant.vendorCode}
                            >
                              {merchant.vendorCode} - {merchant.name}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col xl={4} lg={4} md={6} sm={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>Country Code</Form.Label>
                        <Form.Select
                          name="country_code"
                          value={itemData.country_code}
                          onChange={handleChange}
                          disabled={fetchingData}
                        >
                          <option value="">Select Country</option>
                          {countryOptions.map((country) => (
                            <option key={country.code} value={country.code}>
                              {country.code} - {country.name}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col xl={4} lg={4} md={6} sm={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>Region Code</Form.Label>
                        <Form.Select
                          name="region_code"
                          value={itemData.region_code}
                          onChange={handleChange}
                          disabled={!itemData.country_code || fetchingData}
                        >
                          <option value="">Select Region</option>
                          {regionOptions.map((region) => (
                            <option key={region.code} value={region.code}>
                              {region.code} - {region.name}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>
                </>
              )}

              <Row>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Item Group</Form.Label>
                    <Form.Select
                      name="item_group"
                      value={itemData.item_group}
                      onChange={handleChange}
                      disabled={fetchingData}
                    >
                      <option value="">Select Item Group</option>
                      {itemGroupOptions.map((group) => (
                        <option key={group.code} value={group.code}>
                          {group.code} - {group.description}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Item Group 1</Form.Label>
                    <Form.Select
                      name="item_group1"
                      value={itemData.item_group1}
                      onChange={handleChange}
                      disabled={!itemData.item_group || fetchingData}
                    >
                      <option value="">Select Item Group 1</option>
                      {itemGroup1Options.map((group) => (
                        <option key={group.code} value={group.code}>
                          {group.code} - {group.description}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Item Group 2</Form.Label>
                    <Form.Select
                      name="item_group2"
                      value={itemData.item_group2}
                      onChange={handleChange}
                      disabled={!itemData.item_group1 || fetchingData}
                    >
                      <option value="">Select Item Group 2</option>
                      {itemGroup2Options.map((group) => (
                        <option key={group.code} value={group.code}>
                          {group.code} - {group.description}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Item Group 3</Form.Label>
                    <Form.Select
                      name="item_group3"
                      value={itemData.item_group3}
                      onChange={handleChange}
                      disabled={!itemData.item_group2 || fetchingData}
                    >
                      <option value="">Select Item Group 3</option>
                      {itemGroup3Options.map((group) => (
                        <option key={group.code} value={group.code}>
                          {group.code} - {group.description}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Item Indicator 1</Form.Label>
                    <Form.Control
                      type="text"
                      name="item_indicator1"
                      value={itemData.item_indicator1}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Item Indicator 2</Form.Label>
                    <Form.Control
                      type="text"
                      name="item_indicator2"
                      value={itemData.item_indicator2}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Item Indicator 3</Form.Label>
                    <Form.Control
                      type="text"
                      name="item_indicator3"
                      value={itemData.item_indicator3}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

        <div className="fields-btn-container" style={{ marginTop: 16 }}>
          <Button
            variant="primary"
            type="submit"
            className="fields-submit"
            disabled={loading || fetchingData}
          >
            {loading ? "Saving..." : "Save Item"}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default ItemMaster;
